import React, { Component } from 'react';
import {array, bool, func, object} from 'prop-types';
import { append, contains, pluck, union, without } from 'ramda';

// Redux
import { connect } from 'react-redux';
import { setHeaderTitle } from '../../../../actions/header/headerActions';
import { getMedications, requestRefill } from '../../../../actions/medication/medicationActions';
import * as MedicationTypes from '../../../../actions/medication/types';

// Components
import Layout from '../../../Layout/Layout';
import LoadingState from '../../../LoadingState/LoadingState';
import MedicationsList from '../MedicationsList';
import SecondaryHeaderBar from '../../../SecondaryHeaderBar/SecondaryHeaderBar';
import FixedSecondaryHeaderBar from "../../../FixedSecondaryHeaderBar/FixedSecondaryHeaderBar"
import BaseBackButton from "./../../../BaseBackButton/BaseBackButton";

import cx from 'classnames';
import s from './MedicationsLandingPage.css';


const requestRefillIcon =
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="5659 1599 18.75 30" className={s.requestRefillIcon}>
    <g transform="translate(3980 1507)">
      <rect width="18.75" height="23.438" rx="5" transform="translate(1679 98.563)"/>
      <rect width="13.125" height="3.75" transform="translate(1681.813 96.688)"/>
      <rect width="18.75" height="3.75" rx="1.875" transform="translate(1679 92)"/>
    </g>
  </svg>;

export class MedicationsLandingPage extends Component {
  static propTypes = {
    getMedications: func,
    requestRefill: func,
    setHeaderTitle: func,
    loadingState: object,
    medications: array,
    parentCallback: func,
    hasParentSecondaryMenu: bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedMedications: [],
    };
  }

  componentWillMount() {
    this.props.setHeaderTitle('My Medications');
    this.props.getMedications();
  }

  handleRequestRefills = () => this.props.requestRefill({ medications: this.state.selectedMedications });

  handleSelectMedication = (id) => {
    const isChecked = contains(id, this.state.selectedMedications);
    if (!isChecked) {
      this.setState({
        selectedMedications: append(id, this.state.selectedMedications),
      });
    } else {
      this.setState({
        selectedMedications: without(id, this.state.selectedMedications),
      });
    }
  };

  handleSelectAllMedications = () => {
    const areAllSelected = this.props.medications.length > 0 && this.props.medications.length === this.state.selectedMedications.length;
    if (!areAllSelected) {
      this.setState({
        selectedMedications: union(pluck('id', this.props.medications), this.state.selectedMedications),
      });
    } else {
      this.setState({
        selectedMedications: [],
      })
    }
  };

  goBack = () => {
    // Medications Landing Page doesn't have any SlidingPanel components to block it, so it is always visible
    // if you click the Back button, then push out Root Container's ContentPanel to show the Secondary menu while in mobile view
    this.props.parentCallback(true);
  }

  render = () => {
    const listLoading = contains(MedicationTypes.GET_MEDS, this.props.loadingState.requests);
    const refillLoading = contains(MedicationTypes.REQUEST_MED_REFILL, this.props.loadingState.requests);

    return (
      <Layout column visibleXScroll>
        {
            this.props.hasParentSecondaryMenu &&
            <FixedSecondaryHeaderBar className={cx(s.MedicationsLandingPageBackButtonContainer)}>
              <BaseBackButton onClick={this.goBack} buttonLabel={"Medications"} />
            </FixedSecondaryHeaderBar>
        }

        <SecondaryHeaderBar className={s.secondaryHeaderBar}>
          <h1 className={s.headerText}>Check any medications you would like to refill then click</h1>
          { refillLoading ?
            <div className={s.btnLoadingContainer}>
              <LoadingState context={MedicationTypes.REQUEST_MED_REFILL}/>
            </div>
            :
            <button className={cx(s.btn, s.requestRefillsBtn)} disabled={refillLoading} onClick={this.handleRequestRefills}>
              {requestRefillIcon}
              <span className={s.requestRefillText}>Request Refills</span>
            </button>
          }
        </SecondaryHeaderBar>
        { listLoading ?
          <div className={s.bodyLoadingContainer}>
            <LoadingState context={MedicationTypes.GET_MEDS}/>
            <p>Loading your list of medications</p>
          </div>
          :
          <MedicationsList
            medications={this.props.medications}
            onSelect={this.handleSelectMedication}
            onSelectAll={this.handleSelectAllMedications}
            selectedMedications={this.state.selectedMedications}
          />
        }
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  loadingState: state.loadingState,
  medications: state.medications,
});

const mapDispatchToProps = dispatch => ({
  getMedications: () => dispatch(getMedications()),
  requestRefill: data => dispatch(requestRefill(data)),
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MedicationsLandingPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Health/MedicationsLandingPage/MedicationsLandingPage.js